import React, { useEffect, useState } from "react";
import BasicTable from "../../../components/InfoDisplay/InfoDisplay";
import useSave from "../../../Hooks/useSave";
import { useParams, useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import { Autocomplete, TextField, Input } from "@mui/material";

const Packaging = () => {
  const { fetchGraphql } = useSave();
  const { id } = useParams();

  const packagingColumns = [
    {
      id: "productCode",
      name: "Package code",
      edit: true,
    },
    {
      id: "productName",
      name: "Package Name",
      edit: true,
    },
    {
      id: "productCategory",
      name: "Package Category",
      edit: true,
    },
    {
      id: "piecesPerBuom",
      name: "Pieces per BUOM",
      edit: true,
      type: "number",
    },
    {
      id: "productPrice",
      name: "price",
      type: "number",
      edit: true,
    },
  ];

  const [packagingRows, setPackagingRows] = useState([]);

  useEffect(() => {
    fetchGraphql({
      query: `query Products($productId: ID) {
        productPackaging(productId: $productId) {
          productId
          productCode
          productName
          productCategory
          piecesPerBuom
          productPrice
        }
      }`,
      variables: { productId: id },
    }).then((result) => {
      setPackagingRows(result.data.productPackaging);
    });
  }, []);

  const pOptions = {
    handleEdit: (e, row, columnId, index) => {
      setPackagingRows((rows) => {
        const copyState = [...rows];

        columnId === "productPrice" || columnId === "piecesPerBuom"
          ? (copyState[index][columnId] = Number(e.target.value))
          : (copyState[index][columnId] = e.target.value);
        
        return copyState;
      });
    },
    addRecord: () => {
      setPackagingRows((rows) => [
        ...rows,
        {
          productCode: "",
          productName: "",
          productCategory: "",
          productDescription: "",
          productUnitOfMeasure: "",
        },
      ]);
    },
    handleDelete: (row, index) => {
      fetchGraphql({
        query: `mutation DeleteProduct($productId: ID) {
          deleteProduct(productId: $productId)
        }`,
        variables: { productId: packagingRows[index].productId },
      }).then((result) => {
        result.data.deleteProduct
          ? setPackagingRows((rows) => {
              const copyState = [...rows];

              copyState.splice(index, 1);

              return copyState;
            })
          : alert("Error deleting packaging");
      });
    },
    handleSave: (index) => {
      // console.log("save", packagingRows[index]);

      packagingRows[index].productId
        ? fetchGraphql({
            query: `mutation UpdateProduct($productId: ID, $product: ProductInput) {
              updateProduct(productId: $productId, product: $product)
            }
            `,
            variables: {
              productId: packagingRows[index].productId,
              product: packagingRows[index],
            },
          })
        : fetchGraphql({
            query: `mutation CreateProducts($productId: ID, $product: [ProductInput]) {
              createProducts(productId: $productId, product: $product)
            }
            `,
            variables: {productId: id, product: [packagingRows[index]] },
        }).then(result => {
          setPackagingRows((rows) => {
            const copyState = [...rows];

            copyState[index].productId = result.data.createProducts

            return copyState;
          });
          
        })
    },
    handleDontSave: (originalRow, index) => {
      setPackagingRows((rows) => {
        const copyState = [...rows];

        copyState[index] = originalRow

        return copyState;
      });
    }
  };

  return (
    // <Box sx={{height: '100%' , overflow: "hidden"}}>
    <BasicTable
      columns={packagingColumns}
      key="2"
      rows={packagingRows}
      header="Packaging"
      options={pOptions}
    />
    // </Box>
  );
};

export default Packaging;
